import { Reveal } from '@/components/ui/Reveal'

const stats = [
  { l: 'Turfs listed nationwide', n: '500+' },
  { l: 'Bookings made', n: '50K+' },
  { l: 'Cities covered', n: '120+' },
  { l: 'Average player rating', n: '4.8★' },
]

export function StatsBar() {
  return (
    <div className="max-w-7xl mx-auto" style={{ borderBottom: '1px solid var(--lime-line)' }}>
      <div className="grid grid-cols-2 md:grid-cols-4">
        {stats.map((s, i) => (
          <Reveal
            className={`px-8 py-9 ${i < stats.length - 1 ? 'border-r' : ''} ${i < 2 ? 'border-b md:border-b-0' : ''}`}
            delay={i * 0.08}
            key={s.n}
            style={{ borderColor: 'var(--lime-line)' }}
          >
            <div
              className="font-display font-bold text-[2.4rem] leading-none mb-1"
              style={{ color: 'var(--lime)' }}
            >
              {s.n}
            </div>
            <div className="text-[0.78rem]" style={{ color: 'var(--muted)' }}>
              {s.l}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  )
}
